<template>
  <div class="autocomplete">
    <h2 class="autocomplete__title">Enter address</h2>

    <div class="autocomplete__content">
      <input
        type="text"
        ref="autocomplete"
        @focus="geolocate"
        class="autocomplete__input"
        :placeholder="'Enter address'"
        v-model="autocompleteValue"
      />
    </div>

    <div class="buttons buttons_mt">
      <button class="btn btn_primary" @click="close">Close</button>

      <button
        class="btn"
        @click="save"
        :disabled="(!isValid || result.length < 2)"
        :class="{
                    'disabled':(!isValid || result.length < 2)
                }"
      >Apply</button>
    </div>
  </div>
</template>


<script>
export default {
  name: "auto-complete",
  props: {
    disabled: {
      required: false,
      type: Boolean
    },
    className: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      autocomplete: null,
      fieds: ["route", "street_number", "postal_code", "locality", "country"],
      autocompleteValue: "",
      result: [],
      data: null,
      allowSave: false,
      autocompleteListener: null
    };
  },
  computed: {
    isValid() {
      const re = /[0-9]/;

      if (this.autocompleteValue.match(re) == null) {
        this.allowSave = false;
        return false;
      }

      if (!this.allowSave) {
        return false;
      }

      return true;
    }
  },
  methods: {
    initInput() {
      if (window.google != undefined) {
        this.autocomplete = new window.google.maps.places.Autocomplete(
          this.$refs["autocomplete"],
          { types: ["geocode"] }
        );

        this.autocomplete.setComponentRestrictions({
          country: ["at"]
        });

        this.autocomplete.setFields(["address_component", "geometry"]);

        this.autocompleteListener = window.google.maps.event.addListener(
          this.autocomplete,
          "place_changed",
          () => {
            this.fillInAddress();
          }
        );
      }
    },
    fillInAddress() {
      this.result = [];
      const places = this.autocomplete.getPlace();

      places.address_components.forEach(element => {
        if (this.fieds.lastIndexOf(element.types[0]) != -1) {
          this.result.push(element);
        }
      });

      this.data = {
        address: {
          house: this.result[0].short_name,
          route: this.result[1].short_name,
          index: this.result[4].short_name,
          city: this.result[2].short_name,
          country: this.result[3].long_name
        },
        location: {
          lat: places.geometry.location.lat(),
          lng: places.geometry.location.lng()
        }
      };

      this.allowSave = true;
    },
    geolocate() {
      if (
        window.navigator.geolocation &&
        window.google != undefined &&
        this.autocomplete != undefined
      ) {
        window.navigator.geolocation.getCurrentPosition(position => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new window.google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });

          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    save() {
      this.$emit("done", this.data);
      this.close();
    },
    close() {
      this.autocompleteValue = "";
      this.$emit("close");
      this.result = [];
    }
  },
  mounted() {
    this.initInput();
  },
  destroyed() {
    window.google.maps.event.removeListener(this.autocompleteListener);
    window.google.maps.event.clearInstanceListeners(this.autocomplete);

    if (document.querySelector(".pac-container")) {
      document.querySelector(".pac-container").remove();
    }
  }
};
</script>

<style lang="scss" scoped>
.autocomplete {
  width: 350px;
  padding: 20px;

  &__input {
    padding-left: 20px;
    width: calc(100% - 30px);
    color: #4d4d4d;
    height: 45px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    color: #444;
    font-size: 16px;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 126px;
    height: 40px;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    margin: 20px auto 10px;

    background-color: #f07300;
    transition: all 0.5s;
    cursor: pointer;
    position: relative;
    z-index: 9;
  }
}

.autocomplete .disabled_hover-orange {
  background: #f07300 !important;
}
</style>